import { useEffect } from 'react';
import { moveIntercom } from './intercom-actions';

export const useMoveIntercomAway = (type = 'projectButtons') => {
    const styleForElement = () => {
        switch (type) {
            case 'projectButtons':
                return 'var(--intercom-bottom-project)';
            case 'publishBanner':
                return 'var(--intercom-bottom-publish-banner)';
            default:
                return;
        }
    };

    useEffect(() => {
        const style = styleForElement({ type });
        moveIntercom(style);

        return () => {
            moveIntercom();
        };
    }, []);
};
